module.exports = __webpack_public_path__ + "img/logo_SNB_정부.1954ff52.svg";